/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createDetailFieldHook } from '../../core/factories/createDetailFieldHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetMarketRow } from '../openapi-types.gen.js';
import { type useGetMarketArgs, useGetMarketSpec, useGetMarketRealtime } from '../specs/markets.spec.gen.js';

export type { GetMarketRow } from '../openapi-types.gen.js';
export type { useGetMarketArgs } from '../specs/markets.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): pubkey, mints.
 */
export const useGetMarket = createHook(useGetMarketSpec, useGetMarketRealtime);


/**
 * Per-field subscription hook for the \`useGetMarket\` cache entry.
 * Pass the SAME args as the parent hook (same queryKey → same cache). Returns the named field's value; only the call site
 * re-renders when that field changes (TanStack tracked-properties +
 * per-component `select`).
 *
 *     function Title({ pubkey }) {
 *       const value = useGetMarketField({ pubkey }, 'title');
 *       return <h3>{value}</h3>;
 *     }
 */
export const useGetMarketField = createDetailFieldHook<useGetMarketArgs, GetMarketRow>(useGetMarketSpec);

/**
 * Hover/intent prefetch companion for `useGetMarket`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetMarket();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetMarket = createPrefetchHook(useGetMarketSpec);
